import React from "react";
import MetaTags from "react-meta-tags";
import { Col, Row } from "antd";
import "./index.css";
// import { AccountBookFilled } from "@ant-design/icons";
import Question from "./question";

function FrequentAsked() {
  return (
    <React.Fragment>
      {/* <Layout> */}
      <div>
        <MetaTags>
          <title>Frequent Asked Questions | PMT</title>
        </MetaTags>

        <Row className="mb-10">
          <Col span={24}>
            <div className="questions-image">{/* PMTC */}</div>
          </Col>
          <Col span={24}>
            <div>
              <Question />
            </div>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
}

export default FrequentAsked;
